<template>
	<div>
		<div class="main">
			<BaseInput ref="company" :label="$t('company')" v-model="model.company" />

			<PersonNameForm ref="PersonNameForm" v-model="model" :show-company="false" />
			<div class="flex space-x-4">
				<BaseInput
					ref="BaseInput.model.street"
					class="w-full md:w-1/2 pr-0"
					:label="$t('street')"
					type="text"
					v-model="model.street"
					:required="true"
				/>

				<BaseInput
					ref="BaseInput.model.houseNumber"
					class="w-full md:w-1/2"
					:label="$t('number')"
					type="text"
					v-model="model.houseNumber"
					:required="false"
				/>
			</div>

			<CityInput :required="true" ref="cityinput" v-model="model.city" />

			<div class="flex space-x-4">
				<BaseInput ref="BaseInput.model.phone" :required="true" class="w-full" :label="$t('phone')" v-model="model.phone" type="text" />
				<BaseInput :required="true" ref="BaseInput.model.email" class="w-full" :label="$t('e_mail')" v-model="model.email" type="text" />
			</div>
		</div>
	</div>
</template>

<script>
import PersonNameForm from '@/components/forms/PersonNameForm';
import BaseInput from '@/components/forms/inputs/BaseInput';
import CityInput from '@/components/forms/CityInput';
import Validate from '@/mixins/Validate';
import DamageAssessorApplicationRepository from '@/api/repositories/DamageAssessorApplicationRepository';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'ApplyDamageAssessor',
	components: { CityInput, BaseInput, PersonNameForm },
	mixins: [Validate, Authentication],
	data() {
		return {
			model: {
				city: {},
			},
			isLoading: false,
		};
	},
	mounted() {
		if (!this.isUserAllowedInLevel5or6) {
			this.$emit('authNotAllowed');
		} else {
			this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
		}
	},
	methods: {
		save() {
			if (!this.validate()) {
				this.$swal(this.$t('general.attention').toString(), this.$('please_check_input'), 'warning');
				return;
			}
			this.$store.commit('setConfirmLeaving', false);
			this.isLoading = true;

			DamageAssessorApplicationRepository.store(this.model).then(() => {
				this.$swal(this.$t('general.success').toString(), this.$t('request_applied_system_message').toString(), 'success').then(() => {
					this.$store.dispatch('updateDamageAssessorApplications');
					this.$router.replace({ name: 'repair_shop.service_provider' });
				});
			});
		},
	},
};
</script>

<style scoped></style>
